document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".sliding_text-btn");

  buttons.forEach((btn) => {
    // Keyboard interaction support
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        btn.click();
      }
    });
  });
});

class MarqueeSlider extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.marqueeInstance = null;
  }

  connectedCallback() {
    // Wait for jQuery and marquee plugin to be available
    this.waitForDependencies().then(() => {
      this.init();
      this.setupAccessibilityListeners();
    });
  }

  async waitForDependencies() {
    // Poll for jQuery and marquee plugin
    return new Promise((resolve) => {
      const checkDependencies = () => {
        if (typeof $ !== 'undefined' && $.fn.marquee) {
          resolve();
        } else {
          setTimeout(checkDependencies, 100);
        }
      };
      checkDependencies();
    });
  }

  init() {
    if (this.initialized) return;

    /**
     * WCAG 2.1 Compliance: Respect users who prefer reduced motion.
     * Motion-sensitive users may experience vertigo or nausea from moving text.
     */
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.style.overflowX = 'auto';
      this.style.display = 'block';
      console.info('Marquee animation disabled: User prefers reduced motion.');
      return; 
    }
    
    const speed = window.innerWidth <= 768 
      ? parseInt(this.dataset.mobileSpeed) || 75
      : parseInt(this.dataset.speed) || 100;

    /**
     * Initialize the marquee plugin with Pause on Hover functionality.
     * This satisfies the requirement for users to be able to stop movement to read content.
     */
    this.marqueeInstance = $(this).marquee({
      speed: speed,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true,
      pauseOnHover: true // Critical for ADA compliance
    });

    this.initialized = true;
  }

  /**
   * ACCESSIBILITY LOGIC (Keyboard Navigation)
   * Essential for users navigating via Tab key or assistive technologies.
   */
  setupAccessibilityListeners() {
    // Pause animation when a keyboard user tabs into a link within the slider
    this.addEventListener('focusin', () => {
      if (this.initialized) $(this).marquee('pause');
    });

    // Resume animation when the focus leaves the slider area
    this.addEventListener('focusout', () => {
      if (this.initialized) $(this).marquee('resume');
    });

    // Accessibility: Allow manual pause/play toggle using the Space key
    this.addEventListener('keydown', (e) => {
      if (e.code === 'Space') {
        e.preventDefault();
        const marqueeData = $(this).data('marquee');
        if (marqueeData) {
          const isPaused = marqueeData.paused;
          $(this).marquee(isPaused ? 'resume' : 'pause');
        }
      }
    });
  }

  // Handle resize to reinitialize with correct speed
  static observedAttributes = ['data-speed', 'data-mobile-speed'];

  attributeChangedCallback() {
    if (this.initialized) {
      $(this).marquee('destroy');
      this.initialized = false;
      this.init();
    }
  }
}

// Register the custom element
if (!customElements.get('marquee-slider')) {
  customElements.define('marquee-slider', MarqueeSlider);
}